import React, { useContext } from "react";
import JoseLuisIMG from "../../assets/app/TeamSection/jRueda.png";
import NoreidaCorreiaIMG from "../../assets/app/TeamSection/nCorreia.png";
import RandySojoIMG from "../../assets/app/TeamSection/rSojo.png";
import JoseSalazarIMG from "../../assets/app/TeamSection/jSalazar.png";
import JoelBolivarIMG from "../../assets/app/TeamSection/jBolivar.png";
import LuisRuedaIMG from "../../assets/app/TeamSection/lRuedaCorreia.png";
import SiulRuedaIMG from "../../assets/app/TeamSection/sRuedaCorreia.png";
import JorgeVargasIMG from "../../assets/app/TeamSection/jVargas.png";
import JoseLuisLightIMG from "../../assets/app/TeamSection/jRuedaLight.png";
import NoreidaCorreiaLightIMG from "../../assets/app/TeamSection/nCorreiaLight.png";
import RandySojoLightIMG from "../../assets/app/TeamSection/rSojoLight.png";
import JoseSalazarLightIMG from "../../assets/app/TeamSection/jSalazarLight.png";
import JoelBolivarLightIMG from "../../assets/app/TeamSection/jBolivarLight.png";
import LuisRuedaLightIMG from "../../assets/app/TeamSection/lRuedaCorreiaLight.png";
import SiulRuedaLightIMG from "../../assets/app/TeamSection/sRuedaCorreiaLight.png";
import JorgeVargasLightIMG from "../../assets/app/TeamSection/jVargasLight.png";
import TeamCard from "./TeamCard";
import { useTranslation } from "react-i18next";

import "../../styles/app/TeamSection.css";
import { ThemeContext } from "../../contexts/ThemeContext";

const TeamSection: React.FC = () => {
  const { t } = useTranslation();

    const themeContext = useContext(ThemeContext);
  
    if (!themeContext) {
      throw new Error("ThemeContext must be used within a ThemeProvider");
    }
  
    const { isLightMode } = themeContext;

  const team = [
    {
      src: isLightMode ? JoseLuisLightIMG : JoseLuisIMG,
      name: "JOSÉ LUIS RUEDA",
      role: t("teamSection.roles.0"),
      email: "info@tuagentevirtual.ai",
      linkedin: "https://www.linkedin.com/in/jose-luis-rueda/",
    },
    {
      src: isLightMode ? NoreidaCorreiaLightIMG : NoreidaCorreiaIMG,
      name: "NORAIDA CORREIA",
      role: t("teamSection.roles.1"),
      email: "",
      linkedin: "",
    },
    {
      src: isLightMode ? LuisRuedaLightIMG : LuisRuedaIMG,
      name: "LUIS IGNACIO RUEDA",
      role: t("teamSection.roles.2"),
      email: "",
      linkedin: "",
    },
    {
      src: isLightMode ? SiulRuedaLightIMG : SiulRuedaIMG,
      name: "SIUL JOSÉ RUEDA",
      role: t("teamSection.roles.3"),
      email: "",
      linkedin: "",
    },
    {
      src: isLightMode ? RandySojoLightIMG : RandySojoIMG,
      name: "RANDY SOJO",
      role: t("teamSection.roles.4"),
      email: "",
      linkedin: "",
    },
    {
      src: isLightMode ? JoseSalazarLightIMG : JoseSalazarIMG,
      name: "JOSÉ SALAZAR",
      role: t("teamSection.roles.5"),
      email: "",
      linkedin: "",
    },
    {
      src: isLightMode ? JoelBolivarLightIMG : JoelBolivarIMG,
      name: "JOEL BOLÍVAR",
      role: t("teamSection.roles.6"),
      email: "",
      linkedin: "",
    },
    {
      src: isLightMode ? JorgeVargasLightIMG : JorgeVargasIMG,
      name: "JORGE VARGAS",
      role: t("teamSection.roles.7"),
      email: "",
      linkedin: "",
    },
  ];

  return (
    <section className="team-section">
      <div className="team-heading">
        <h1 className="team-title">{t("teamSection.title")}</h1>
      </div>
      <div className="team-grid">
        {team.map((t, index) => (
          <TeamCard
            key={index}
            src={t.src}
            name={t.name}
            role={t.role}
            email={t.email}
            linkedin={t.linkedin}
          />
        ))}
      </div>
    </section>
  );
};

export default TeamSection;
